<template>
  <nuttrema-layout-west-slide width="25%" minWidth="35em">
    <west-slide-left-navigation slot="navigation-top">
      <router-link
         tag="a" activeClass="is-active" exact
        :title="$t('label.cancel')"
        :to="{ name: _get(meta, 'navigation.cancel') }">
        <nuttrema-iconica-sidebar-link icon="far fa-times" theme="white"></nuttrema-iconica-sidebar-link>
      </router-link>
    </west-slide-left-navigation>
    <!-- end ~ navigation-top -->

    <nuttrema-layout-west-three-vertical>
      <div slot="top-center" class="top--center__title">
        <span>{{ $t(_get(meta, 'title')) }}</span>
      </div>

      <template slot="center">
        <nuttrema-loader
           v-if="ProgramDaySchedule.fetching || StuffToEatDetails.fetching || StuffToEatContents.fetching"
          :showText="false">
        </nuttrema-loader>
        <form-cred-stuff-to-eat-complex-schedule
           v-else
          :id="id"
          :type="type"
          :dayID="dayID"
          :entityID="entityID"
          :scheduleID="scheduleID"
          :ProgramDay="ProgramDay"
          :StuffToEatContents="StuffToEatContents"
          :ProgramDaySchedule="ProgramDaySchedule"
          :ProgramDaySchedules="ProgramDaySchedules"
          @cancel="onCancelEvent"
          @submit="onFormSubmitEvent"
          @addServingSize="onAddServingSize"
          @removeSchedule="onRemoveSchedule">
        </form-cred-stuff-to-eat-complex-schedule>
      </template>
    </nuttrema-layout-west-three-vertical>
  </nuttrema-layout-west-slide>
</template>

<script>
import { mapActions } from 'vuex';

import * as Event from 'constants/event';
import PageProps from 'components/mixins/page-props';
import { STUFF_TO_EAT, PROGRAMS_KEYS } from 'constants/types';

import NuttremaLayoutWestSlide from 'components/ui/layout/nuttrema-layout-west-slide';
import WestSlideLeftNavigation from 'components/ui/west-slide-component/west-slide-left-navigation';
import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';

import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';
import FormCredStuffToEatComplexSchedule from './form-cred-stuff-to-eat-complex-schedule';

export default {
  name: 'page-edit-stuff-to-eat-complex-schedule',
  mixins: [
    PageProps,
  ],
  components: {
    NuttremaLayoutWestSlide,
    WestSlideLeftNavigation,
    NuttremaIconicaSidebarLink,
    NuttremaLayoutWestThreeVertical,
    FormCredStuffToEatComplexSchedule,
  },
  props: {
    id: {
      required: true,
      default: null,
    },
    type: {
      required: false,
      default: PROGRAMS_KEYS.diet,
    },
    dayID: {
      required: true,
      default: null,
    },
    scheduleID: {
      required: true,
      default: null,
    },
    entityID: {
      required: true,
      default: null,
    },
    entityType: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      STUFF_TO_EAT,
    };
  },
  computed: {
    ProgramDay() {
      return this.$store.getters.ProgramDay(this.id);
    },
    ProgramDaySchedule() {
      return this.$store.getters.ProgramDaySchedule(this.scheduleID);
    },
    ProgramDaySchedules() {
      return this.$store.getters.ProgramDaySchedules(this.id);
    },
    StuffToEatDetails() {
      return this.$store.getters.StuffToEatDetails(this.entityID);
    },
    StuffToEatContents() {
      return this.$store.getters.StuffToEatContents(this.entityID);
    },
  },
  methods: {
    ...mapActions([
      'EditProgramDaySchedule',
      'AddStuffToEatServingSize',
      'RemoveProgramDaySchedule',
    ]),
    onFormSubmitEvent(payload) {
      console.log('onFormSubmitEvent', payload);
      this.EditProgramDaySchedule({
        id: this.id,
        type: this.type,
        dayID: this.dayID,
        scheduleID: this.scheduleID,
        payload,
      }).then(() => {
        window.Eventus.$emit(Event.SCHEDULES_CHANGED);
        this.successNotification({ label: 'label.schedule' });
        this.onSuccessEvent();
      }).catch((error) => {
        console.error(error);
        this.errorNotification({ label: 'label.schedule' });
      });
    },
    onAddServingSize(data) {
      console.log('onAddServingSize', data);
      this.AddStuffToEatServingSize(data).then(() => {
        this.successNotification({ label: 'label.serving_size' });
      }).catch(() => {
        this.errorNotification({ label: 'label.serving_size' });
      });
    },
    onRemoveSchedule(data) {
      console.log('onRemoveSchedule', data);
      this.RemoveProgramDaySchedule(data).then(() => {
        console.log('remove was successfully!');
        window.Eventus.$emit(Event.SCHEDULES_CHANGED);
        this.successNotification({ label: 'label.schedule', message: 'message.default_success_delete_message' });
        this.onSuccessEvent();
      }).catch((error) => {
        console.error(error);
        this.errorNotification({ message: 'message.default_error_delete_message' });
      });
    },
  },
  created() {
    this.$store.dispatch('GetStuffToEatDetails', { id: this.entityID, type: this.entityType });
    this.$store.dispatch('GetStuffToEatContents', { id: this.entityID, type: this.entityType });
    this.$store.dispatch('GetProgramDaySchedule', {
      id: this.id,
      type: this.type,
      dayID: this.dayID,
      scheduleID: this.scheduleID,
    });
  },
  beforeDestroy() {
    this.$store.dispatch('ClearStuffToEatDetails', { id: this.entityID });
    this.$store.dispatch('ClearProgramDaySchedule', { scheduleID: this.scheduleID });
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/programs/shared/schedules/cred/page-edit-stuff-to-eat-complex-schedule.vue